var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#515151"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.88 11.2901L14 15.1701L10.12 11.2901C10.0274 11.1975 9.9175 11.124 9.79653 11.0739C9.67557 11.0238 9.54592 10.998 9.41499 10.998C9.28406 10.998 9.15441 11.0238 9.03345 11.0739C8.91248 11.124 8.80257 11.1975 8.70999 11.2901C8.61741 11.3826 8.54397 11.4926 8.49386 11.6135C8.44376 11.7345 8.41797 11.8641 8.41797 11.9951C8.41797 12.126 8.44376 12.2556 8.49386 12.3766C8.54397 12.4976 8.61741 12.6075 8.70999 12.7001L13.3 17.2901C13.69 17.6801 14.32 17.6801 14.71 17.2901L19.3 12.7001C19.3927 12.6076 19.4662 12.4977 19.5164 12.3767C19.5666 12.2557 19.5924 12.126 19.5924 11.9951C19.5924 11.8641 19.5666 11.7344 19.5164 11.6134C19.4662 11.4925 19.3927 11.3826 19.3 11.2901C18.91 10.9101 18.27 10.9001 17.88 11.2901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDownArrow);
export default __webpack_public_path__ + "static/media/export-down-arrow.0995e8c79694ddd831c894a8d3a4fada.svg";
export { ForwardRef as ReactComponent };